var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataCapture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.439 12.896a5.394 5.394 0 1 0 0-10.789 5.394 5.394 0 0 0 0 10.789zm4.83-.711a6.728 6.728 0 1 0-1.022.864l1.99 1.989a.667.667 0 1 0 .942-.943l-1.91-1.91zm-6.226-5.11V4.16h-.822l-.81.439v.672l.72-.382h.02v2.188h.892zm2.177.075c.218.121.476.182.774.183.3 0 .557-.06.773-.18.217-.122.385-.297.503-.526.118-.229.177-.504.177-.826 0-.32-.058-.592-.176-.816a1.2 1.2 0 0 0-.502-.511 1.603 1.603 0 0 0-.775-.177c-.298 0-.556.059-.774.176a1.202 1.202 0 0 0-.501.51c-.117.225-.176.497-.177.818 0 .32.058.594.175.823.118.229.286.404.503.526zm1.153-.674a.445.445 0 0 1-.653.12.612.612 0 0 1-.187-.29 1.562 1.562 0 0 1-.065-.505c.002-.3.051-.52.149-.658a.444.444 0 0 1 .65-.115c.08.06.142.155.187.282.045.127.067.29.067.491.001.307-.048.532-.148.675zM7.047 8.42v2.916h-.893V9.15h-.02l-.72.381v-.672l.81-.438h.823zm3.666 2.916V8.42H9.89l-.81.438v.672l.72-.381h.02v2.187h.893z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCapture);
export default __webpack_public_path__ + "static/media/dataCapture.679b901a77b2f2c9b9f36c7c1fdf34ee.svg";
export { ForwardRef as ReactComponent };